import { vendorRoutes } from '@/features/vendors/routes'
import AuthMiddleware from '../middlewares/AuthMiddleware'

import { Outlet } from 'react-router-dom'
import { UserRole } from '@/features/auth/auth.constant'
import config, { APP_MODE } from '@/config'

const isProduction = config.mode == APP_MODE.PRODUCTION

const VendorRoutes = [
  {
    breadcrumb: 'BREADCRUMB_VENDOR',
    path: isProduction ? '/' : '/external',
    element: (
      <AuthMiddleware userRoles={[UserRole.VENDOR]}>
        <Outlet />
      </AuthMiddleware>
    ),
    children: vendorRoutes,
  },
]

export default VendorRoutes
